import * as yup from 'yup';
export const commonCommonAccountDtlValidation: { [x: string]: any; } = {
    chargeOnCompany: yup.string().required("Missing."),
    billToCompany: yup.string().required("Missing."),
    percentage: yup.number().min(0, "Percentage must be range from 0 to 100").max(100, "Percentage must be range from 0 to 100").required("Missing.")
};
export const createCommonAccountDtlValidation: { [x: string]: any; } = {
    ...commonCommonAccountDtlValidation,
};
export const createCommonAccountDtlValidationSchema = yup.object().shape(createCommonAccountDtlValidation); 
